import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";

export const getRCSDashboard = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/summary",
    {},
    token,
  );
  return response.data;
};

export const getRCSGraphDashboardByHour = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/summary-by-hour",
    {},
    token,
  );

  return response.data;
};

export const getRCSProcessingMessages = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/messagespending",
    {},
    token,
  );
  return response.data;
};

export const getRCSByPartner = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/messagesmrybypartner",
    {},
    token,
  );

  return response.data;
};

export const getRCSByCarrier = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/summary-by-carrier",
    {},
    token,
  );

  return response.data;
};

export const getRCSHealthApi = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/messagesmry",
    {},
    token,
  );
  return response.data;
};

export const getRCSHealthApiDetail = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/messagesmry-detail",
    {},
    token,
  );
  return response.data;
};

export const getRCSErrors = async ({ token }) => {
  const response = await httpClient(
    "GET",
    ApiEndpoint + "dashboard/rcs/errors",
    {},
    token,
  );
  return response.data;
};